import { DataCellProps } from '../types';

export const TeamMembersCell = ({ team }: DataCellProps) => {
  return <div>{team.actives_count}</div>;
};
